import { useQuery } from "@/api/swr/useQuery";
import { companyDetailSchema } from "@/schema/console/companies/CompanyDetail";

export function useGetCompanyDetail(id: string) {
  return useQuery(companyDetailSchema, `/console/companies/${id}`);
}
